export default __webpack_public_path__ + "static/media/header_edge_green.48615bd9.png";